module.exports = __webpack_public_path__ + "img/goldring_anfertigung.e2eafe9c.png";